<template>
    <div class="menu-action-setting">
        <el-button size="small" type="primary" @click="addOrUpdateHandle()">
            新建主菜单
        </el-button>
        <!--<el-button size="small" type="info" @click="" icon="el-icon-plus">-->
            <!--展开所有-->
        <!--</el-button>-->
        <!--<el-button size="small" type="info" @click="" icon="el-icon-minus">-->
            <!--收起所有-->
        <!--</el-button>-->
        <el-table
                size="small"
                :default-expand-all="expandAll"
                :tree-props="{children: 'menuEntityList', hasChildren: 'hasChildren'}"
                :data="dataList"
                row-key="id"
                style="width: 100%;"
                :height="tableHeight"
        >

          <el-table-column
            prop="permissionName"
            header-align="center"
            min-width="150"
            label="名称"
          >
          </el-table-column>
            <el-table-column
                    header-align="center"
                    align="center"
                    label="图标">
                <template slot-scope="scope">
                    <i v-if="scope.row.icon" :class="scope.row.icon" style="font-size: 16px;"></i>
                </template>
            </el-table-column>
            <el-table-column
                    prop="permissionType"
                    header-align="center"
                    align="center"
                    label="类型">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.permissionType === 1" size="small">目录</el-tag>
                    <el-tag v-else-if="scope.row.permissionType === 2" size="small" type="success">菜单</el-tag>
                    <el-tag v-else-if="scope.row.permissionType === 3" size="small" type="info">按钮</el-tag>
                </template>
            </el-table-column>
            <el-table-column
                    prop="sortNo"
                    header-align="center"
                    align="center"
                    label="排序号">
            </el-table-column>
            <el-table-column
                    prop="routerUrl"
                    header-align="center"
                    align="center"
                    width="150"
                    :show-overflow-tooltip="true"
                    label="菜单URL">
            </el-table-column>
            <el-table-column
                    prop="expression"
                    header-align="center"
                    align="center"
                    width="150"
                    :show-overflow-tooltip="true"
                    label="权限标识">
            </el-table-column>
            <el-table-column
                    prop="remark"
                    header-align="center"
                    align="left"
                    width="150"
                    label="备注">
            </el-table-column>
            <el-table-column
                    header-align="center"
                    align="center"
                    width="200"
                    label="操作">
                <template slot-scope="scope">
                    <el-button  v-if="scope.row.permissionType !== 3" type="text" size="small" @click="addChildHandle(null,scope.row.id,scope.row.permissionName, scope.row.nodePath)" icon="el-icon-circle-plus-outline">
                        新建子项
                    </el-button>
                    <el-button type="text" size="small"
                               @click="addOrUpdateHandle(scope.row.id)">
                        修改
                    </el-button>
                    <el-button type="text" size="small"
                               @click="deleteHandle(scope.row.id)">
                        删除
                    </el-button>
                </template>
            </el-table-column>
            <!-- </el-table> -->
        </el-table>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
</template>

<script>
    import {deleteMenuAction, fetchMenuTree} from '@/controller/sys'
    import AddOrUpdate from './menu-action-add-or-update'
    export default {
        data() {
            return {
                expandAll: false,
                documentClientHeight: document.documentElement['clientHeight'] - 220,
                dataForm: {},
                dataList: [],
                dataListLoading: false,
                addOrUpdateVisible: false
            }
        },
        computed: {
            tableHeight: {
                get() {
                    return this.$store.state.common.documentClientHeight - 215
                }
            }
        },
        components: {
            AddOrUpdate
        },
        activated() {
            this.getDataList()
        },
        methods: {
            // 获取数据列表
            getDataList() {
                this.dataListLoading = true
                fetchMenuTree().then(data => {
                    this.dataList = data.body
                    this.dataListLoading = false
                })
            },
            // 新增 / 修改
            addOrUpdateHandle(id) {
                this.addOrUpdateVisible = true
                this.$nextTick(() => {
                    this.$refs.addOrUpdate.init(id)
                })
            },
            addChildHandle(id, parentId, parentName, parentPath) {
                this.addOrUpdateVisible = true
                this.$nextTick(() => {
                    this.$refs.addOrUpdate.init(null, parentId, parentName, parentPath)
                })
            },
            // 删除
            deleteHandle(id) {
                this.$confirm(`确定对删除操作?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteMenuAction({},id).then(data => {
                        if (data && data.code === '00') {
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                                duration: 1500,
                                onClose: () => {
                                    this.getDataList()
                                }
                            })
                        } else {
                            this.$message.error(data.msg)
                        }
                    })
                }).catch(() => {
                })
            }
        }
    }
</script>
<style lang="scss">
    .menu-action-setting{
        .el-dialog__body {
            .ma-dialog-form {
                width: 95%;
            }
        }
    }
</style>
